/**
 * CSS class manipulation tool
 *
 * Usage:
 *
 * className({
 *   'css-class-name-1': true,      // this key is added to final className
 *   'css-class-name-2': false,     // this key is NOT added
 *   'css-class-name-3': myVariable // this key is added if myVariable is truthy
 * })
 *
 * @returns {string}
 */

export default function className(config) {
  const classList = [];
  Object.entries(config).forEach(([cN, condition]) => {
    if (condition) {
      classList.push(cN);
    }
  });
  return classList.join(' ');
}
